import { makeStyles } from '@material-ui/core';
import React from 'react';
import MuiDrawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import { RepliconDrawer } from '~/modules/common/components';
import { useMeContext } from '~/modules/me/useMeContext';
import AddResourceRequestDrawerDetails from './AddResourceRequestDrawerDetails';

const useStyles = makeStyles(theme => ({
  paper: {
    width: 700,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}));

export const AddResourceRequestDrawer = ({
  project,
  onClose,
  open,
  isMobile = false
}) => {
  const classes = useStyles();
  const {
    featureFlags: { isPsaRmp2025Q3WcagEnabled, isPsaRmp2025Q4WcagEnabled }
  } = useMeContext();

  const DrawerComponent = isPsaRmp2025Q3WcagEnabled
    ? RepliconDrawer
    : MuiDrawer;

  return (
    <DrawerComponent
      anchor="right"
      open={open}
      classes={classes}
      trapFocusWithDatePicker={isPsaRmp2025Q4WcagEnabled}
    >
      <AddResourceRequestDrawerDetails
        project={project}
        onClose={onClose}
        isMobile={isMobile}
      />
    </DrawerComponent>
  );
};

AddResourceRequestDrawer.propTypes = {
  project: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  isMobile: PropTypes.bool
};

export default AddResourceRequestDrawer;
